export default __webpack_public_path__ + "static/media/kashier_card.77ae3e95.svg";